import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const NotificationEmptyState = ({ filterType, onClearFilters }) => {
  const getEmptyStateContent = () => {
    if (filterType === 'unread') {
      return {
        icon: 'CheckCircle',
        iconClassName: 'text-success',
        iconBgClassName: 'bg-success/10',
        title: 'Tudo em dia!',
        message:
          'Você não tem notificações não lidas no momento. Quando algo novo chegar, aparecerá aqui.',
        showButton: true,
        buttonText: 'Ver todas as notificações',
      };
    }

    if (filterType !== 'all') {
      return {
        icon: 'Filter',
        iconClassName: 'text-muted-foreground',
        iconBgClassName: 'bg-muted/40',
        title: 'Nenhuma notificação encontrada',
        message: 'Não há notificações para o filtro selecionado.',
        showButton: true,
        buttonText: 'Limpar filtros',
      };
    }

    return {
      icon: 'Bell',
      iconClassName: 'text-primary',
      iconBgClassName: 'bg-primary/10',
      title: 'Nenhuma notificação',
      message:
        'Quando houver atualizações importantes sobre documentos, licenças ou assinaturas, elas aparecerão aqui.',
      showButton: false,
    };
  };

  const content = getEmptyStateContent();

  return (
    <div className="bg-card border border-border rounded-xl p-8 md:p-12 text-center shadow-elevation-sm">
      <div
        className={`flex items-center justify-center w-16 h-16 md:w-20 md:h-20 rounded-full mx-auto mb-4 md:mb-6 ${content.iconBgClassName}`}
      >
        <Icon
          name={content.icon}
          size={32}
          className={content.iconClassName}
        />
      </div>
      <h3 className="text-xl md:text-2xl font-semibold text-foreground font-heading mb-2 md:mb-3">
        {content.title}
      </h3>
      <p className="text-sm md:text-base text-muted-foreground font-body max-w-md mx-auto mb-6 md:mb-8">
        {content.message}
      </p>
      {content.showButton && (
        <Button
          variant="outline"
          size="default"
          iconName="RotateCcw"
          iconPosition="left"
          onClick={onClearFilters}
        >
          {content.buttonText}
        </Button>
      )}
    </div>
  );
};

export default NotificationEmptyState;
